/*************************************************/
/* COUNTER                                       */
/*************************************************/

export function counter() {
    const numberSelector = '.counter-component__item-number';
    const duration = 2000;

    // Grouping and decimal separators have to match the number Razor already
    // rendered, so format against the document's culture rather than the browser's
    const locale = document.documentElement.lang || undefined;

    const format = (value, decimals) => value.toLocaleString(locale, {
        minimumFractionDigits: decimals,
        maximumFractionDigits: decimals,
    });

    const animate = (el, target, decimals) => {
        let start = null;

        const step = (now) => {
            // First frame sets the baseline: the gap between observing the element
            // and the frame landing would otherwise count as elapsed time
            if (start === null) start = now;

            const progress = Math.min((now - start) / duration, 1);
            const eased = 1 - Math.pow(1 - progress, 3);

            el.textContent = format(target * eased, decimals);

            if (progress < 1) {
                requestAnimationFrame(step);
                return;
            }

            // Land on the server-rendered string, not our own formatting of the
            // target — rounding at the last frame could differ by a digit
            el.textContent = el.dataset.counterFinal;
        };

        requestAnimationFrame(step);
    };

    const init = () => {
        const numbers = [...document.querySelectorAll(numberSelector)];
        if (!numbers.length) return;

        numbers.forEach(el => { el.dataset.counterFinal = el.textContent; });

        // Nothing to animate towards, and no observer worth attaching
        const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        if (reducedMotion || !('IntersectionObserver' in window)) return;

        const observer = new IntersectionObserver((entries) => {
            entries.forEach(entry => {
                if (!entry.isIntersecting) return;

                const el = entry.target;
                observer.unobserve(el);

                const target = parseFloat(el.dataset.counterTarget);
                if (Number.isNaN(target)) return;

                animate(el, target, parseInt(el.dataset.counterDecimals, 10) || 0);
            });
        }, { threshold: 0.5 });

        numbers.forEach(el => observer.observe(el));
    };

    init();
}
